import React, { useDebugValue, useEffect, useState } from "react";
import Dashboard from "../layouts/Dashboard";
import { Card, message } from "antd";
import $ from "jquery";
import { Button } from "reactstrap";
import axios from "../services/axios";
import XTable from "./XTable";
// import { message } from "antd";
import Select from "react-select";
import { If } from "react-condition";
import ReactLoading from "react-loading";
import isConsultant from "../services/isConsultant";
import { checkPermission } from "../utils/checkPermission";
import useRole from "../hooks/useRole";

//datatable
var dt = require("datatables.net");
require("datatables.net-bs4");
$.DataTable = dt;

const ConsultantMapping = (props) => {

    const [regConsultant, setRegConsultant] = useState([])
    const [editDetails, setEditDetails] = useState({})
    const [consultantName, setConsultantName] = useState([])
    const [formTemplate, setFormTemplate] = useState([])
    const [formId, setFormId] = useState([])
    const [formErr, setFormErr] = useState("")
    const [status, setStatus] = useState(false)

    // initialize state for error
    const [nameErr, setNameErr] = useState("")
    const [emailErr, setEmailErr] = useState("")
    const [phoneErr, setPhoneErr] = useState("")

    const [canCreateConsultantMapping, setCanCreateConsultantMapping] = useState(false);
    const [canEditConsultantMapping, setCanEditConsultantMapping] = useState(false);
    const [canEditStatusConsultantMapping, setCanEditStatusConsultantMapping] = useState(false);
    const userRole = useRole();

    const checkPermissions = async () => {
      try {
        const createAllowed = await checkPermission(
          userRole,
          "consultant_mapping_module",
          "create_consultant_mapping"
        );
        const editAllowed = await checkPermission(
          userRole,
          "consultant_mapping_module",
          "edit_consultant_mapping"
        );
        const editStatusAllowed = await checkPermission(
          userRole,
          "consultant_mapping_module",
          "edit_status_consultant_mapping"
        );
        setCanCreateConsultantMapping(createAllowed);
        setCanEditConsultantMapping(editAllowed);
        setCanEditStatusConsultantMapping(editStatusAllowed);
      } catch (err) {
        console.error("Error checking consultant mapping permissions:", err);
      }
    };

    useEffect(() => {
      checkPermissions();
    }, [userRole]);

    const success = (e) => {
      if(e === "submit"){
        message.success("Consultant mapped, Successfully", 5);
      }
      else if(e === "error"){
        message.error("Email or Phone already exist ", 5);
      }
      else if(e === "update"){
        message.success("Updated, Successfully", 5);
      }
    }

    const [name, setName] = useState("")

    const handleName = (e) => {
      setNameErr("");
      setName(e.target.value);
    };
   
    const [email, setEmail] = useState("")
    const  handleEmail = (e) => {
      setEmailErr("");
      const emailValidate = /\S+@\S+\.\S+/;
  
      if (!e.target.value.match(emailValidate)) {
        setEmailErr("invalid email format");
      }
      setEmail(e.target.value);
    }

    const [phone, setPhone] = useState("")
    const  handlePhone = (e) => {
      let isnum = /^\d+$/;

      setPhoneErr("");
      if (!isnum.test(e.target.value)) {
        setPhoneErr("Only numbers are allowed");
      }
      if (e.target.value.length > 10 || e.target.value.length < 10) {
        setPhoneErr("Only 10 digits are allowed");
      }
      if(e.target.value.length === 0){
        setPhoneErr("");
      }
      setPhone(e.target.value);
    }

    const _id = localStorage.getItem('user.id')

    const handleCreate = async(e) => {
      e.preventDefault()
      if(nameErr === "" && emailErr === "" && phoneErr === "" && formErr === ""){
        if(name === ""){
          setNameErr("Name is required field")
        }
        else if(email === ""){
          setEmailErr("Email is required field")
        }
        else if(formId.length <= 0){
          setFormErr("Please select form")
        }
        else{
          await axios.post("/registerConsultant", {
            name: name.replace(/\s{2,}/g, " ").trim(),
            email: email.replace(/\s{2,}/g, " ").trim().toLocaleLowerCase(),
            phone: phone.replace(/\s{2,}/g, " ").trim(),
            status: true,
            formId: formId,
            role: "consultant",
            loginUserId : _id
        }, 
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        }
        )
        .then(res  => {
          fetchData()
          setName("")
          setEmail("")
          setPhone("")
          setFormId([])
          success("submit")
        })
        .catch(err => {
          success("error")
          // console.log("data err err", err.response.data.error.message)
        })
        }
      }
     
    }

    const handleUpdate = async(e) => {
      e.preventDefault()
      if(nameErr === "" && emailErr === "" && phoneErr === ""){
        if(name === "" || name === "Select Consultant Name..."){
          setNameErr("Name is required field")
        }
        else if(email === ""){
          setEmailErr("Email is required field")
        }
        else{
          await axios.patch(`/registerConsultant/ChangeDetails/${editDetails._id}`, {
            name: name.replace(/\s{2,}/g, " ").trim(),
            email: email.replace(/\s{2,}/g, " ").trim().toLocaleLowerCase(),
            phone: phone.replace(/\s{2,}/g, " ").trim(),
            formId: formId,
            // status: true,
            role: "consultant",
        }, 
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        }
        )
        .then(res  => {
          fetchData()
          setName("")
          setEmail("")
          setPhone("")
          setFormId([])
          setEditDetails([])
          success("update")
        })
        .catch(err => {
          success("error")
        })
        }
      }
     
    }

    const handleMultipleValues = (e) => {
      setFormErr("")
      setFormId(e) 
    }

   async function fetchData(){
     await axios.get("/registerConsultant", {
        headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
    })
    .then(res => {
        const data = res.data
        setRegConsultant(data)
    })
    }

   async function fetchConsultantName(){
    await axios.get("/consultant/ConsultantName", {
      headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
  })
  .then(res => {
      const data = res.data
      setConsultantName(data)
  })
   }

   async function fetchForm(){
    await axios.get(`/formtemplate`, {
      headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
  })
     .then(res => {
         setFormTemplate(res?.data)
     })
 }

    useEffect(() => {
      fetchForm()
      fetchData()
      fetchConsultantName()
    }, [])

    //edit event handler
    const handleEdit = (id) => {
      setNameErr("")
      setEmailErr("")
      setPhoneErr("")
      regConsultant.filter(ele => {
        
        if(ele._id === id){
          setName(ele.name)
          setEmail(ele.email)
          setPhone(ele.phone)
          setEditDetails(ele)
          setFormId(ele.formId)
        }
      })
    }

    const statusUpdate = (e) => {
      if(e === "submit"){
        message.success("Status updated successfully")
      }
    }

    // Consultant Login Status
    const handleStatus = async(id, status) => {
     await axios.patch(`/registerConsultant/ChangeConsultantStatus/${id}`,
     {
      status: !status
     },
     {
        headers: {Authorization: `Bearer ${localStorage.getItem("user.token")}`}
     }
     )
     .then(res => {
      fetchData()
        statusUpdate("submit")
     })
    }

    return (
     <div>
       {!isConsultant() && <Dashboard title="Consultant Mapping">
        <div className="row mb-4">
        <div className="col-lg-4">
            <div>
            <Card className="border">
                <div>
              {/* // consultant dropdown */}
                <div>
                  <label>Consultant Name</label>
                  <select
                    id="FormType"
                    className="form-control"
                    onChange={handleName}
                    value={name}
                  >
                    <option >
                      {"Select Consultant Name..."}
                    </option>
                    {consultantName?.map((ele) => {
                      return <option value={ele}>{ele}</option>;
                    })}
                  </select>
                  {nameErr && (
                    <div
                      className="text-danger"
                      style={{ marginTop: 5 + "px" }}
                    >
                      {nameErr}
                    </div>
                  )}
                </div>

                <div className="mt-2">
                  <label>Email</label>
                  <input
                    placeholder="Enter Email"
                    onChange={handleEmail}
                    name="email"
                    value={email}
                    type="text"
                    class="form-control"
                    id="usr"
                  />
                  {emailErr && (
                    <div
                      className="text-danger"
                      style={{ marginTop: 5 + "px" }}
                    >
                      {emailErr}
                    </div>
                  )}
                </div>

                <div className="mt-2">
                  <label>Phone</label>
                  <input
                    placeholder="Enter Phone Number"
                    onChange={handlePhone}
                    name="phone"
                    value={phone}
                    type="text"
                    class="form-control"
                    id="usr"
                  />
                  {phoneErr && (
                    <div
                      className="text-danger"
                      style={{ marginTop: 5 + "px" }}
                    >
                      {phoneErr}
                    </div>
                  )}
                </div>
                <div className="mt-2">
                <label>Select Form</label>
                  <Select
                      isMulti
                      value={formId?.map((option) => {
                      return {
                        label: option.label,
                        value: option.value,
                      };
                    })}

            options={formTemplate?.map((option) => {
              return {
                label: option.name,
                value: option._id,
              };
            })}
            onChange={handleMultipleValues}
                  ></Select>
                  {formErr && (
                    <div
                      className="text-danger"
                      style={{ marginTop: 5 + "px" }}
                    >
                      {formErr}
                    </div>
                  )}
                </div>

                {canCreateConsultantMapping && (
                  <>
                  {!editDetails._id ?
                   <button onClick={handleCreate}  className="btn btn-primary mt-3">
                    Create
                  </button>: 
                  <button onClick={handleUpdate}  className="btn btn-primary mt-3">
                  Update
                </button>
                  }
                  </>
                )}
                </div>
            </Card>
            </div>
        </div>
            {/* show data details */}
        <div className="col-lg-8">
          <Card className="border">
            <XTable
              columns={["ID", "Name", "Email", "Phone", "Action", "Status"]}
              rows={regConsultant?.map((ele) => {
                // console.log("ele status", ele.status)
                return {
                  ID: ele?._id,
                  Name: ele?.name,
                //   Process: ele?.processId[0]?.name,
                  Email: ele?.email,
                  Phone: ele?.phone,
                  Action: (
                    <div style={{ display: "flex" }}>
                      {canEditConsultantMapping && (
                      <Button
                        size="sm"
                        type="primary"
                        className="btn btn-primary"
                        onClick={() => {
                          handleEdit(ele._id);
                        }}
                          // id={ele._id}
                          // onClick={handleDeleteQuestion}
                          disabled={!ele?.status ? true : false}
                      >
                        <i class="fa fa-edit"></i> Edit
                      </Button>
                      )}
                    </div>
                  ),
                  Status: (
                    <div style={{ display: "flex" }}>
                      {canEditStatusConsultantMapping && (
                      <Button
                        size="sm"
                        type="primary"
                        // className="btn btn-primary"
                        className={`btn btn-primary ${!ele?.status && 'inactive-button'}`}
                        onClick={() => {
                          handleStatus(ele._id, ele.status);
                        }}
                      >
                         {ele?.status ? <span >Active</span> : <span>InActive</span>}
                      </Button>
                      )}
                    </div>
                  )
                };
              })}
            />
          </Card>
        </div>
        </div>
        </Dashboard>}
     </div>     
    )
}

export default ConsultantMapping